import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { ColorPalette } from 'shared/consts/colorPalette';
import Collapse from 'shared/ui/collapse';
import { useFileEditorStore } from 'store/file-editor';

const FileDetails: FC = () => {
	const { t } = useTranslation();
	const { fileDetails } = useFileEditorStore();

	const fileDetailsContent = useMemo(
		() => [
			{
				lable: t('shared_texts.table_columns.status'),
				content: fileDetails?.status,
				visible: true,
			},
			{
				lable: t('shared_texts.table_columns.imported_at'),
				content: (
					<>
						{fileDetails?.createdAt
							? format(new Date(fileDetails?.createdAt), 'HH:mm dd/MM/yyyy')
							: '-'}
					</>
				),
				visible: true,
			},
			{
				lable: t('shared_texts.table_columns.source'),
				content: fileDetails?.uploadSource,
				visible: true,
			},
			{
				lable: t('shared_texts.table_columns.category'),
				content: t(`sidebar.menu./files/${fileDetails?.category}`),
				visible: !!fileDetails?.category,
			},
		],
		[fileDetails],
	);

	return (
		<Collapse title={t('files.details.files')}>
			{fileDetailsContent.map((item, index) =>
				item.visible ? (
					<Box
						key={`details-${index}`}
						sx={{
							display: 'flex',
							alignItems: 'center',
						}}
					>
						<Typography
							variant={'body2'}
							color={ColorPalette.baliHai}
							sx={{ display: 'flex', alignItems: 'center', flex: '1 1' }}
						>
							{item.lable}
						</Typography>
						<Typography
							variant={'body2'}
							color={ColorPalette.astronaut}
							sx={{ display: 'flex', alignItems: 'center', flex: '1 1' }}
						>
							{item.content}
						</Typography>
					</Box>
				) : null,
			)}
		</Collapse>
	);
};

export default FileDetails;
